export default __webpack_public_path__ + "static/media/twitter.0f05cb93.svg";